import { render, staticRenderFns } from "./SpecialistManagement.vue?vue&type=template&id=ae94c408&scoped=true"
import script from "./SpecialistManagement.vue?vue&type=script&lang=js"
export * from "./SpecialistManagement.vue?vue&type=script&lang=js"
import style0 from "./SpecialistManagement.vue?vue&type=style&index=0&id=ae94c408&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae94c408",
  null
  
)

export default component.exports